import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';

export type Getters = {
  colorpickerBody(state: State): string | null | undefined;
  colorpickerEdge(state: State): string | null | undefined;
  colorpickerEdgeGlosiness(state: State): string | null | undefined;
  colorpickerEdgeMetalness(state: State): string | null | undefined;
  colorpickerThread(state: State): string | null | undefined;
  colorpickerInside(state: State): string | null | undefined;
  colorpickerTack(state: State): string | null | undefined;
}

export const getters: GetterTree<State, RootState> & Getters = {
  colorpickerBody: (state) => state.colorpickerBody,
  colorpickerEdge: (state) => state.colorpickerEdge,
  colorpickerEdgeGlosiness: (state) => state.colorpickerEdgeGlosiness,
  colorpickerEdgeMetalness: (state) => state.colorpickerEdgeMetalness,
  colorpickerThread: (state) => state.colorpickerThread,
  colorpickerInside: (state) => state.colorpickerInside,
  colorpickerTack: (state) => state.colorpickerTack,
};
